import { ResponsiveContainer, PieChart, Pie, LabelList, Cell, Tooltip, Legend, Label } from "recharts";

const colors = ["#9cc177", "#509ee3"];

export default (props) => {
  const data = props.data.map(i => ({
    period: i.period === "Afternoon" ? "Tarde" : "Manhã",
    count: i.count
  }));

  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <PieChart>
          <Tooltip />
          <Legend />

          <Pie data={data} nameKey="period" dataKey="count">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index]} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 400px;
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// components/stats/PerPeriodStats.js